export default __webpack_public_path__ + "static/media/warn_icon.1d77691b.svg";